/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MobileConnectedProvidersService {
    /**
     * Disconnect the mobile user's connection to a provider
     * Sever the acting user's link to one provider.
     *
     * The acting user and tenant ride in gRPC metadata (set by
     * validate_mobile_session_v2), so only provider_id is passed.
     * @param providerId
     * @param xMobileAuth
     * @returns void
     * @throws ApiError
     */
    public static disconnectProvider(
        providerId: string,
        xMobileAuth?: (string | null),
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/mobile/v1/connected-providers/{provider_id}',
            path: {
                'provider_id': providerId,
            },
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
